const defaultContent = `Ai sensi degli artt. 1341 e 1342, c.c., le disposizione delle Condizioni Generali di Contratto di seguito:
indicate Art. 5. (Conettività e trasmissione dei dati), Art. 7. (Identificativi ed accessi al sistema), 
Art. 9. (Responsabilità dei contenuti e dei dati), Art. 10. (Responsabilità di InfoCert), Art. 11. (Responsabilità dell'Utilizzatore), 
Art. 12. (Risoluzione), Art. 13. (Cessazione del Servizio), Art. 15. (Procedure di reclamo e di risoluzione delle controversie), 
Art. 16. (Norme imperative - Perdita del diritto di Recesso).`;
const UnFairClauses = function (titleArg, contentArg) {
    const content = contentArg || defaultContent;
    const title = titleArg;
    this.open = function () {
        const modal = document.getElementById("myModal");
        const span = document.getElementsByClassName("close")[0];
        const titleH1 = document.getElementById('unfair-clauses-text-title');
        const contentDiv = document.getElementById('unfair-clauses-text-content');
        modal.style.display = "block";
        contentDiv.innerHTML = content;
        titleH1.innerText = title;
        // When the user clicks on <span> (x), close the modal
        span.onclick = function () {
            modal.style.display = "none";
        };
        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        };
    };
    return this;
};
module.exports = UnFairClauses;
//# sourceMappingURL=UnFairClauses.js.map